import { getMetricFormatRule } from '@/pages/benchmark/utils/utils';
import { getEchartTooltipString } from '@/pages/dashboard/components/EchartsTooltip';
import { IColumn } from '@/pages/dashboard/components/EchartsTooltip/type';
import { getName } from '@home/utils/common';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import React from 'react';

export const getAllMetricTooltip = (props: any) => {
  const {
    metricConfig,
    metricGroupList,
    currentMetric,
    isEn,
    params,
    series,
    seriesConfig, // 新增：接收 seriesConfig 配置
  } = props;

  const { group_name_en, group_name_cn } = metricConfig?.[currentMetric] || {};
  const nameColTitle = getName(isEn, group_name_en, group_name_cn);

  const columns: IColumn[] = [
    {
      key: 'name',
      header: nameColTitle,
      showIcon: true,
    },
  ];

  // 动态生成指标列
  const metricColList =
    metricGroupList?.map((item: any) => {
      const { group_label_en, group_label_cn, metric: colMetric } = item || {};
      const name = getName(isEn, group_label_en, group_label_cn);
      const currentMetricConfig = metricConfig?.[colMetric] || {};
      const seriesName = params?.[0].axisValueLabel;
      // 根据名称匹配当前在哪列
      const isCurrentColStyle = seriesName === name ? { color: '#f4cf8b' } : undefined;

      return {
        key: colMetric,
        header: <span style={isCurrentColStyle}>{name}</span>,
        render: (value: any, row: any) => {
          // 检查当前行对应的 series 是否配置了 skipFormat 或有百分比数据
          const currentSeries = series?.find((s: any) => s.name === row?.name);
          const currentSeriesConfig = seriesConfig?.find((c: any) => 
            getName(isEn, c.nameEn, c.nameCn) === row?.name
          );
          
          // 如果配置了 skipFormat，直接返回原始值
          if (currentSeriesConfig?.skipFormat || currentSeries?.skipFormat) {
            // 从 parsedData 中获取原始值
            const colIndex = metricGroupList?.findIndex((m: any) => m.metric === colMetric);
            const originalValue = currentSeries?.parsedData?.[colIndex]?.originalValue;
            if (originalValue !== undefined && originalValue !== null) {
              return originalValue;
            }
          }
          
          // 如果原始值是百分比格式，返回原始值
          const colIndex = metricGroupList?.findIndex((m: any) => m.metric === colMetric);
          const parsedItem = currentSeries?.parsedData?.[colIndex];
          if (parsedItem?.isPercent && parsedItem?.originalValue !== undefined) {
            return parsedItem.originalValue;
          }
          
          const valueFormatRule = getMetricFormatRule(currentMetricConfig);
          return dataFormat({ value, formatRule: valueFormatRule });
        },
        style: isCurrentColStyle
      };
    }) || [];

  columns.push(...metricColList);

  // 组装数据
  const newData = series?.map((item: any, index: number) => {
    const { name, data: sData } = item;
    const itemData: any = {
      name,
      color: params[index].color,
    };
    metricGroupList?.forEach((item: any, index: number) => {
      const { metric } = item || {};
      itemData[metric] = sData[index];
    });
    return itemData;
  });

  return getEchartTooltipString({
    table: {
      columns,
      data: newData,
      sortBy: 'value',
    },
  });
};
